import { useThreadsContext } from "connected-components/ai-teammate/hooks/context"
import ChatSidePanel from "./side-panel"
import ChatThreadRegion from "./thread-region"

export default function ChatWorkspace() {
  const { isPreferencesLoaded } = useThreadsContext()

  // Wait for preferences so a restored open conversation does not flicker through an empty thread.
  if (!isPreferencesLoaded) {
    return null
  }

  return <div className="connected-components_agent-chat">
    <ChatSidePanel />
    <main className="chat-main">
      <ChatThreadRegion />
    </main>
  </div>
}
